import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Details } from '@digdir/designsystemet-react';

import { CalculationParameterMap } from '../../../../../types/calculationParameters';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { SummaryCard } from '../../../../../screens/expertRegistration/json/common/summary/styledComponents';

import { SmallScreenItem } from './smallScreenItem';
import { LargeScreenItem } from './largeScreenItem';
import { StyledDetails } from './styledComponents';

interface CategoriesProps {
  beregningskjerneInput: CalculationParameterMap;
}

export const Categories: FC<CategoriesProps> = ({ beregningskjerneInput }) => {
  const { t } = useTranslation();
  const { xsScreen } = useMediaQuery();

  return (
    <SummaryCard>
      {Object.entries(beregningskjerneInput)
        .filter(([categoryKey]) => categoryKey !== '$type')
        .map(([categoryKey, category]) => {
          return (
            <StyledDetails key={categoryKey}>
              <Details.Summary>{t(`register.parameters.category.${categoryKey}`)}</Details.Summary>
              <Details.Content>
                {xsScreen ? <SmallScreenItem category={category} /> : <LargeScreenItem category={category} />}
              </Details.Content>
            </StyledDetails>
          );
        })}
    </SummaryCard>
  );
};
